<div class="d-flex flex-row justify-content-between px-3">
  <h2 mat-dialog-title class="headingBL titleHead">
    {{ gettitle(data.title) }}<span> {{ gettitle(data.title, true) }}</span>
  </h2>
  <img
    mat-dialog-actions
    (click)="closeDialog()"
    src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_close.png"
    alt="close"
    style="width: 2.8rem; height: 2rem"
    class="point"
  />
</div>
<div mat-dialog-content class="d-flex flex-row gap-2 w-100">
  <div class="vtext1" style="font-weight: 500" *ngIf="data.discription !== ''">
    <div
      style="
        width: 15rem;
        height: 15rem;
        border-radius: 30rem;
        float: left;
        overflow: hidden;
        margin: 1.5rem;
      "
    >
      <img
        [src]="data.img"
        alt="data.title"
        style="width: 100%; height: 100%; object-fit: cover"
      />
    </div>
    {{ data.discription }}
  </div>
</div>
